import Container from "../element/container";
import { MDBModalBody } from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import FullModal from "./full.modal";
import Icon from "../element/icon";
import AccountModalHeader from "../common/account.modal.header";
import { getOrderDocuments, groupOrderDocuments } from "../../helpers/order.documents";
import { openIfPrivate } from "../../helpers/secure.file";

const imageExtensions = ["png", "jpg", "jpeg", "gif", "webp", "bmp", "heic", "svg"];

// The API only hands back a file name, so the extension is all we have to tell
// a scanned document apart from a photo.
const fileKind = (name = "") => {
  const extension = name.split("?")[0].split(".").pop().toLowerCase();
  if (extension === "pdf") return { tone: "pdf", icon: "bi:file-earmark-pdf" };
  if (imageExtensions.includes(extension))
    return { tone: "image", icon: "solar:gallery-linear" };
  return { tone: "file", icon: "solar:file-linear" };
};

export default function OrderDocumentsModal({ order, onClose }) {
  const { t } = useTranslation();
  const documents = getOrderDocuments(order).map((file) => ({
    ...file,
    kind: fileKind(file.name),
  }));
  const groups = groupOrderDocuments(documents);
  const name = order?.name || order?.product?.name || "Vehicle";
  const reference = order?.reservationId || order?.reference_no || "-";
  return (
    <FullModal independent show close={onClose} showCloseButton centered scrollable screenSize="lg"
      className="product-action-modal saved-car-modal order-documents-modal"
      dialogClassName="action-modal-dialog saved-car-modal-dialog"
      contentClassName="action-modal-content saved-car-modal-content"
      content={
        <MDBModalBody className="saved-car-modal-body order-documents-dialog">
          <AccountModalHeader title={t("Vehicle Documents")} subtitle={`${name} | ${reference}`} icon="solar:document-text-linear" />
          <Container tag="div" className="order-documents-list">
            {groups.map((group) => (
              <section className="order-document-category" key={group.key}>
                <h3>{t(group.label)}</h3>
                {group.files.map((file) => (
                  <article className="order-document-row" key={file.url}>
                    <span className={`order-document-icon ${file.kind.tone}`}>
                      <Icon tag="span" icon={file.kind.icon} />
                    </span>
                    <span className="order-document-name">{file.name}</span>
                    <a
                      className="order-document-view"
                      href={file.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      role="button"
                      onClick={(event) => openIfPrivate(event, file.url)}
                    >
                      {t("Open")}
                    </a>
                  </article>
                ))}
              </section>
            ))}
          </Container>
          {!documents.length && (
            <p className="order-documents-empty" role="status">
              {t("No documents available for this order yet.")}
            </p>
          )}
        </MDBModalBody>
      }
    />
  );
}
